import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Text from 'shopper/components/Text';

import toOfferAdditionalInfosText from 'lib/htmlParsers/parseOfferAdditionalInfos';
import placeholder from 'lib/placeholder';

const UserInstructions = ({ instructions }) => {
  const parsed = useMemo(
    () => (instructions ? toOfferAdditionalInfosText(instructions) : null),
    [instructions]
  );

  if (!parsed) {
    return null;
  }

  return (
    <div>
      <Text bold>{placeholder('subtitles.offerAuthorInstructions')}</Text>
      {parsed}
    </div>
  );
};

UserInstructions.propTypes = {
  instructions: PropTypes.string.isRequired,
};

export default UserInstructions;
